/**
 * Advantage Flow's plans (Coleman, 2026-10-24: "we can go live first. prices we can do that at first. and done for
 * you apply for a quote because we need to know level"). DIY is bought on the web (never in the iOS app); done-for-you
 * is quoted from the form on /afs. Live Stripe prices, created 2026-10-24 on the BAM Coaches account.
 * Shared by the server (api/afs-billing.js) and the pages.
 */
export const AFS_PLANS = {
  diy_hs: { id: "diy_hs", label: "High School / Club", price: 79, games: 10, stripePriceId: "price_1UUCu0G8VcQAE5BpLv8EcvFT" },
  // Prep and JUCO (brief 695: "strike a price in the middle"). Its Stripe price is made the first time someone buys it
  // (api/afs-billing.js diyPrice), tagged afs_plan=diy_mid.
  diy_mid: { id: "diy_mid", label: "Prep / JUCO", price: 109, games: 12, stripePriceId: null },
  diy_college: { id: "diy_college", label: "College", price: 149, games: 12, stripePriceId: "price_1UUCu6G8VcQAE5BpBB5w3tSt" },
};
export const planOfPrice = (priceId) => (priceId ? Object.values(AFS_PLANS).find(p => p.stripePriceId === priceId) || null : null);
/**
 * Done for you (Coleman, 2026-10-24: "done for you apply for a quote because we need to know level"; then "i say we
 * just build now"): priced per team. The founder makes an offer from a quote request, which is a Stripe price of its
 * own, tagged afs_plan=dfy with the games a month; the offer link is /#/afs-start?offer=<price id>.
 */
/**
 * What a finished game looks like (the landing page, Getting started): the made-up demo game, Tigers vs Hawks
 * (afsDemoGame.js), at /g/demo. It replaced the Cavs v 76ers game (2026-11-01: no NBA film on a sales page).
 */
export const DEMO_GAME = "/g/demo";
/** What Advantage Flow is, in Coleman's words (Mux asset "AFS Intro", 2026-10-31): the landing page and Getting started. */
export const AFS_INTRO = { playbackId: "B1MbgNmQVeBGd2tNR5HsXR4KJ5dPpmhXq2qhFnlfTYQ", title: "What Advantage Flow is" };
export const DFY = { id: "dfy", label: "Done for you" };
export const isOfferId = (x) => /^price_[A-Za-z0-9]{8,40}$/.test(String(x || ""));
/** A Stripe price as an Advantage Flow plan: a DIY plan by id, or a done-for-you offer by its tags. Null for anything else. */
export function planOf(price) {
  const diy = planOfPrice(price?.id);
  if (diy) return { ...diy, kind: "diy" };
  const m = price?.metadata || {};
  if (m.afs_plan && m.afs_plan !== "dfy" && AFS_PLANS[m.afs_plan]) return { ...AFS_PLANS[m.afs_plan], stripePriceId: price.id, kind: "diy" };
  const games = Number(m.afs_games);
  if (m.afs_plan !== "dfy" || !Number.isInteger(games) || games < 1 || games > 200) return null;
  // A priced quote (2026-10-28) also says how it's billed: a month at a time for the season's months, or the season
  // up front (then the games are the season's).
  const months = Number(m.afs_months);
  return { id: DFY.id, kind: "dfy", label: m.afs_label || DFY.label, games, price: Math.round((price.unit_amount || 0) / 100),
    ...(m.afs_billing === "season" || m.afs_billing === "month" ? { billing: m.afs_billing } : {}), ...(Number.isInteger(months) && months > 0 && months <= 12 ? { months } : {}) };
}
/** Stripe statuses that keep Advantage Flow on. past_due keeps it during Stripe's retries. */
export const LIVE_STATUSES = ["active", "trialing", "past_due"];
/** The levels the done-for-you form asks for, since the quote depends on it. */
export const QUOTE_LEVELS = ["High school", "Club / AAU", "Prep", "JUCO", "College (D1)", "College (D2, D3, NAIA)", "Pro", "International youth"];
export const QUOTE_TAGGING = ["Advantage only", "Advantage + box score", "Everything (box score, minutes, lineups)"];
export const QUOTE_FILM = ["Hudl", "YouTube", "Synergy", "Video files", "Other"];
/**
 * The platform's prices, as the membership checkout knows them (supabase/functions/create-checkout-session keeps the
 * same three). Advantage Flow coaches get the rest of the platform for $19.99 a month while they have a paid plan, and
 * it moves to the monthly price when the plan ends (Coleman, 2026-10-28: "they have to pay an extra $19.99 for the
 * rest"; "it goes up to 34.99 when it ends"). Created in Stripe 2026-10-28.
 */
export const PLATFORM_PRICES = { monthly: "price_1TMbhjG8VcQAE5BpfN0LhHFe", annual: "price_1TMbiEG8VcQAE5BpSBKc4BoQ", afs: "price_1UVdzxG8VcQAE5Bp3Pg4VRS1" };
